<app-notification-banner></app-notification-banner>
<header>
  <nav class="main-nav">
    <div class="header-logo">
      <a [routerLink]="['/']">
        <img src="/assets/logo.svg" alt="Logo" />
      </a>
    </div>
    <div class="header-buttons">
      <div>
        @if(isUserLoggedIn) {
        <div class="d-flex">
          <button class="header-menu-button" (click)="navigateToBilling()">
            <i class="icon-header fa-solid fa-file-invoice"></i>
            <span class="ml-1">Billing</span>
          </button>
          <button class="header-menu-button" [routerLink]="['/monitoring']">
            <i class="icon-header fa-solid fa-table"></i>
            <span>Monitoring</span>
          </button>
          <button [routerLink]="['/dashboard']" id="btnDashboard">
            <i class="icon-header fa-regular fa-user"></i>
            <span>Dashboard</span>
          </button>
        </div>
        } @else {
        <button (click)="login('/dashboard')">
          <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" width="30" height="30" viewBox="0 0 30 37"
            fill="none">
            <path class="svg-path"
              d="M14.7867 24.292C7.8851 24.292 2 25.3264 2 29.4995C2 33.6726 7.84943 34.8496 14.7867 34.8496C21.7241 34.8496 27.5735 33.8152 27.5735 29.6243C27.5735 25.4333 21.7241 24.292 14.7867 24.292Z"
              stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path class="svg-path"
              d="M14.8049 18.3356C16.4196 18.3285 17.9959 17.8431 19.3347 16.9406C20.6736 16.038 21.715 14.7589 22.3272 13.2648C22.9394 11.7706 23.095 10.1285 22.7744 8.54596C22.4537 6.96343 21.6712 5.51138 20.5258 4.37337C19.3803 3.23536 17.9233 2.46247 16.3387 2.15221C14.7541 1.84195 13.113 2.0083 11.6229 2.63027C10.1329 3.25224 8.86062 4.30193 7.96684 5.64668C7.07306 6.99143 6.59783 8.57098 6.60134 10.1857C6.60367 11.2598 6.81793 12.3227 7.23168 13.314C7.64543 14.3052 8.25054 15.2052 9.01255 15.9622C9.77455 16.7193 10.6784 17.3185 11.6724 17.7258C12.6663 18.1331 13.7308 18.3403 14.8049 18.3356Z"
              stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Login</span>
        </button>
        }
      </div>
      <div class="menu-button" (click)="toggleMenu()">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
      <div class="menu" id="menu">
        <span class="close-button" (click)="toggleMenu()">&times;</span>
        <div class="sidemenu-option row p-0">
          <div class="col-1"></div>
          <div class="menu-section1 col-2">
            <img src="/assets/cover1.jpg" alt="nav-bg-image" />
            <div class="inner-menu-section1">
              <a [routerLink]="['/pro']">Spruce <br />
                PRO</a>
              <ul class="menu-option">
                <li>
                  <a [routerLink]="['/environmental-commodities-markets']">Environmental Commodities Markets</a>
                </li>
                <li>
                  <a [routerLink]="['/spruce-servicing']">Spruce Servicing</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="menu-section2 col-2">
            <img src="/assets/cover2.jpeg" alt="nav-bg-image" />
            <div class="inner-menu-section2">
              <a [routerLink]="['/about']">About</a>
              <ul class="menu-option">
                <li>
                  <a href="https://investors.sprucepower.com/news/default.aspx" target="_blank" rel="noopener">News</a>
                </li>
                <li><a [routerLink]="['/careers']">Careers</a></li>
                <li>
                  <a href="https://investors.sprucepower.com/overview/default.aspx" target="_blank"
                    rel="noopener">Investors</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="menu-section3 col-2">
            <img src="/assets/cover3.jpg" alt="nav-bg-image" />
            <div class="inner-menu-section3">
              @if(isUserLoggedIn) {
              <a [routerLink]="['/dashboard']">Dashboard</a>
              <ul class="menu-option">
                <li><a (click)="navigateToBilling()">Billing</a></li>
                <li><a [routerLink]="['/monitoring']">Monitoring</a></li>
                <li><a (click)="logout()">Logout</a></li>
              </ul>
              } @else {
              <a (click)="login('/dashboard')">Sign In</a>
              <ul class="menu-option">
                <li><a (click)="login('/dashboard')">Customer Login</a></li>
                <li><a (click)="signUp('/dashboard')">Customer Registration</a></li>
              </ul>
              }
            </div>
          </div>
          <div class="menu-section4 col-2">
            <img src="/assets/cover4.jpeg" alt="nav-bg-image" />
            <div class="inner-menu-section4">
              <a [routerLink]="['/get-in-touch']">Get In Touch</a>
              <ul class="menu-option">
                <li><a [routerLink]="['/get-in-touch']">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div class="menu-section5 col-2">
            <img src="/assets/cover5.jpg" alt="nav-bg-image" />
            <div class="inner-menu-section5">
              <a [routerLink]="['/life-events']">Life Events</a>
              <ul class="menu-option">
                <li>
                    <a [routerLink]="['/life-events/form/refinance-information-request']">
                      Refinance
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/system-purchase-or-prepayment-request']">
                      System Purchase / Prepayment Request
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/solar-agreement-amendment-request']">
                      Changes to Your Lease
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/home-sale-information/escrow-facilitated-transactions-request']">
                      Home Sale Information (Escrow-Facilitated)
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/home-sale-information/lawyer-facilitated-transactions-request']">
                    Home Sale Information (Non-Escrow-Facilitated)
                  </a>
                  </li>
              </ul>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="menu-mobile">
          <div class="inner-mobile-menu">
            <ul>
              <li class="dropdown-main">
                <a [routerLink]="['/pro']">
                  Spruce PRO
                </a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li>
                    <a [routerLink]="['/environmental-commodities-markets']">Environmental Commodities Markets</a>
                  </li>
                  <li><a [routerLink]="['/spruce-servicing']">Spruce Servicing</a></li>
                </ul>
              </li>
              <li class="dropdown-main">
                <a [routerLink]="['/about']">
                  About
                </a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li><a
                      href="https://investors.sprucepower.com/news/news-details/2024/Spruce-Power-Reports-Second-Quarter-2024-Results/default.aspx"
                      target="_blank" rel="noopener">News</a></li>
                  <li><a [routerLink]="['/careers']">Careers</a></li>
                  <li><a [routerLink]="['/']">Investors</a></li>
                </ul>
              </li>
              @if(isUserLoggedIn){
              <li class="dropdown-main">
                <a [routerLink]="['/dashboard']">
                  Dashboard
                </a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li><a (click)="navigateToBilling()">Billing</a></li>
                  <li><a [routerLink]="['/monitoring']">Monitoring</a></li>
                  <li><a (click)="logout()">Logout</a></li>
                </ul>
              </li>
              } @else {
              <li class="dropdown-main">
                <a (click)="login('/dashboard')">
                  Sign In
                </a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li><a (click)="login('/dashboard')">Customer Login</a></li>
                  <li>
                    <a (click)="signUp('/dashboard')">Create an account</a>
                  </li>
                </ul>
              </li>
              }
              <li class="dropdown-main">
                <a [routerLink]="['/get-in-touch']">
                  Get In Touch
                </a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li>
                    <a [routerLink]="['/get-in-touch']">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </li>
              <li class="dropdown-main">
                <a [routerLink]="['/life-events']">Life Events</a>
                <span class="inner-section-dropdown"></span>
                <ul class="dropdown-menu">
                  <li>
                    <a [routerLink]="['/life-events/form/refinance-information-request']">
                      Refinance
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/system-purchase-or-prepayment-request']">
                      System Purchase / Prepayment Request
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/solar-agreement-amendment-request']">
                      Changes to Your Lease
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/home-sale-information/escrow-facilitated-transactions-request']">
                      Home Sale Information (Escrow-Facilitated)
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/life-events/form/home-sale-information/lawyer-facilitated-transactions-request']">
                    Home Sale Information (Non-Escrow-Facilitated)
                  </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
  @if(isUserLoggedIn) {
  <div class="option-section account-settings">
    <div class="account-button">
      <a class="account" [routerLink]="['/user-settings']"><i class="fa-sharp fa-solid fa-gear"></i> Account
        Settings</a>
    </div>
    <div class="logut-button">
      <a rel="nofollow" class="log-out" (click)="logout()"><i class="fa-solid fa-right-from-bracket"></i>Log out</a>
    </div>
  </div>
  }
</header>
